
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import FieldValidationMixin from "@/components/processing_steps/FieldValidationMixin.vue"

@Component
export default class CurrencyField extends FieldValidationMixin {
  @Prop({ default: '' }) error!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: '' }) maxValue!: string
  @Prop({ default: '' }) value!: string
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: false }) isReadOnly!: boolean
  @Prop({ default: null }) label!: string

  displayError = ''
  state: boolean | null = null
  inputValue = ''

  mounted() {
    this.inputValue = this.formatValue(this.value)
  }

  @Watch('error')
  onErrorChange () {
    this.displayError = this.error
    this.state = this.error ? false : null
  }

  @Emit('input')
  updateValue(event: InputEvent) {
    const input = event.target as HTMLInputElement
    const newValue = input.value

    // when more than 2 decimal places are entered, revert to previous value
    const regex = /^\d*(\.\d{0,2})?$/
    if (!regex.test(newValue) && newValue !== '') {
      input.value = this.inputValue
      return this.inputValue
    }

    if (isNaN(Number(newValue))) {
      this.state = false
      this.displayError = this.$gettext('Please enter a number!')
    } else if (this.maxValue && newValue > this.maxValue) {
      this.state = false
      this.displayError = this.$gettext('Please choose a lower number!')
    } else if (!this.requiredFieldIsEmpty(newValue, this.required) && newValue === '') {
      this.state = false
      this.displayError = this.$gettext('This field is required')
    }
    this.inputValue = newValue
    return newValue
  }

  formatValue(val: string) {
    if (val === '' || isNaN(Number(val))) {
      return val
    }
    return Number(val).toFixed(2)
  }

  onBlur() {
    this.inputValue = this.formatValue(this.inputValue)
  }
}
